import { render, staticRenderFns } from "./InstallationTicketBlock.vue?vue&type=template&id=21cea6cc&scoped=true&"
import script from "./InstallationTicketBlock.vue?vue&type=script&lang=js&"
export * from "./InstallationTicketBlock.vue?vue&type=script&lang=js&"
import style0 from "./InstallationTicketBlock.vue?vue&type=style&index=0&id=21cea6cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cea6cc",
  null
  
)

export default component.exports